<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent && localService.languageContent.startup  && localService.languageContent.common && localService.languageContent.table">
  <div class="banner center" style="max-width:1000px;">
    <div class="row row_header">
      <div class="col-3">
        {{localService.languageContent.common.action}}
      </div>
      <div class="col-9">
        {{localService.languageContent.table.title}}
        <div class="icon_action_header">
          <i class="material-icons on_language_changed" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons" (click)="onOpenStartUp()" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="items">
      <div class="row styled_row" *ngFor="let item of items">
        <div class="col-3">
          <i class="material-icons button icon_adjust" title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ? "toggle_on" : "toggle_off"}}</i>
          <a class="button" *ngIf="parentId == '0'" [routerLink]="['/startup-configs' + localService.basicParamsString,item.key]"><i class="material-icons button icon_adjust">account_tree</i></a>
        </div>
        <div class="col-9">
          <span class="button" (click)="onOpenStartUp(item.key)">{{item.v5}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
